import * as z from "zod";

export {
  changeMsisdnOrchestrator,
  changeSimEsimOrchestrator,
  ftthOrchestrator,
  mobileOrchestrator,
  multiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export const verificationErrorResponse = z.object({
  code: z.enum(["50254", "50255"]),
});
